<template>
    <div class="price-box main">
        <div class="items flex-bt">
            <div class="child">
                <div class="title none">精選電商計劃</div>
                <div class="old-price none"></div>
                <div class="price none">HK$ {{ fee[0] }}<span>/月</span></div>
                <div class="buy none">立即購買</div>
            </div>
            <div class="child">
                <div class="title ">精選電商計劃</div>
                <div class="old-price "></div>
                <div class="price ">HK$498 <span>/月</span></div>
                <div class="buy ">立即購買</div>
            </div>
            <div class="child">
                <div class="title">專業電商計劃</div>
                <div class="old-price"></div>
                <div class="price">HK$1288 <span>/月</span></div>
                <div class="buy">立即購買</div>
            </div>
            <div class="child">
                <div class="title">全方位電商計劃</div>
                <div class="old-price"></div>
                <div class="price">HK$1888 <span>/月</span></div>
                <div class="buy">立即購買</div>
            </div>
        </div>
        <div class="items big-title flex-bt">
            可購式影片
        </div>
        <div class="items flex-bt">
            <div class="child active">
                自建可購式短片
            </div>
            <div class="child">
                <img src="@/assets/images/advantage.png" class="icon" alt="">
            </div>
            <div class="child">
                <img src="@/assets/images/advantage.png" class="icon" alt="">
            </div>
            <div class="child">
                <img src="@/assets/images/advantage.png" class="icon" alt="">
            </div>
        </div>
        <div class="items flex-bt">
            <div class="child active">
                自建可購式直播
                <div class="tips flex-start">
                    <img class="tips-icon" src="@/assets/images/tips.png" alt="">
                    <div class="info">每額外6000分鐘為HK$120</div>
                </div>
            </div>
            <div class="child">
                <img src="@/assets/images/advantage.png" class="icon" alt="">
            </div>
            <div class="child">
                <img src="@/assets/images/advantage.png" class="icon" alt="">
            </div>
            <div class="child">
                <img src="@/assets/images/advantage.png" class="icon" alt="">
            </div>
        </div>
        <div class="items flex-bt">
            <div class="child">
                超正影片主導網店主頁
            </div>
            <div class="child">
                <img src="@/assets/images/advantage.png" class="icon" alt="">
            </div>
            <div class="child">
                <img src="@/assets/images/advantage.png" class="icon" alt="">
            </div>
            <div class="child">
                <img src="@/assets/images/advantage.png" class="icon" alt="">
            </div>
        </div>
        <div class="items big-title flex-bt">
            網店功能
        </div>
        <div class="items flex-bt">
            <div class="child">
                註冊用戶
            </div>
            <div class="child text-center">
                上限1個
            </div>
            <div class="child text-center">
                上限5個
            </div>
            <div class="child text-center">
                上限8個
            </div>
        </div>
        <div class="items flex-bt">
            <div class="child active">
                全港首創KOL配對爆單引擎
            </div>
            <div class="child text-center">
                —
            </div>
            <div class="child text-center">
                —
            </div>
            <div class="child text-center">
                <img src="@/assets/images/advantage.png" class="icon" alt="">
            </div>
        </div>
        <div class="items flex-bt">
            <div class="child ">
                自動化物流智能系統
            </div>
            <div class="child text-center">
                —
            </div>
            <div class="child text-center">
                <img src="@/assets/images/advantage.png" class="icon" alt="">
            </div>
            <div class="child text-center">
                <img src="@/assets/images/advantage.png" class="icon" alt="">
            </div>
        </div>

        <div class="items flex-bt">
            <div class="child ">
                自建產品商城
            </div>
            <div class="child text-center">
                —
            </div>
            <div class="child text-center">
                <img src="@/assets/images/advantage.png" class="icon" alt="">
            </div>
            <div class="child text-center">
                <img src="@/assets/images/advantage.png" class="icon" alt="">
            </div>
        </div>
        <div class="items flex-bt">
            <div class="child ">
                自訂網域
            </div>
            <div class="child text-center">
                —
            </div>
            <div class="child text-center">
                <img src="@/assets/images/advantage.png" class="icon" alt="">
            </div>
            <div class="child text-center">
                <img src="@/assets/images/advantage.png" class="icon" alt="">
            </div>
        </div>
        <div class="items flex-bt">
            <div class="child ">
                免費LOOPSHOP網域
            </div>
            <div class="child text-center">
                <img src="@/assets/images/advantage.png" class="icon" alt="">
            </div>
            <div class="child text-center">
                <img src="@/assets/images/advantage.png" class="icon" alt="">
            </div>
            <div class="child text-center">
                <img src="@/assets/images/advantage.png" class="icon" alt="">
            </div>
        </div>
        <div class="items flex-bt">
            <div class="child ">
                可自行設計主頁
            </div>
            <div class="child text-center">
                <img src="@/assets/images/advantage.png" class="icon" alt="">
            </div>
            <div class="child text-center">
                <img src="@/assets/images/advantage.png" class="icon" alt="">
            </div>
            <div class="child text-center">
                <img src="@/assets/images/advantage.png" class="icon" alt="">
            </div>
        </div>
        <div class="items flex-bt">
            <div class="child active">
                超易手機一鍵直播
            </div>
            <div class="child text-center">
                <img src="@/assets/images/advantage.png" class="icon" alt="">
            </div>
            <div class="child text-center">
                <img src="@/assets/images/advantage.png" class="icon" alt="">
            </div>
            <div class="child text-center">
                <img src="@/assets/images/advantage.png" class="icon" alt="">
            </div>
        </div>
        <div class="items flex-bt">
            <div class="child active">
                獨家執貨專員系統
            </div>
            <div class="child text-center">
                <img src="@/assets/images/advantage.png" class="icon" alt="">
            </div>
            <div class="child text-center">
                <img src="@/assets/images/advantage.png" class="icon" alt="">
            </div>
            <div class="child text-center">
                <img src="@/assets/images/advantage.png" class="icon" alt="">
            </div>
        </div>
        <div class="items flex-bt">
            <div class="child">
                手機及電腦管理網店
            </div>
            <div class="child text-center">
                <img src="@/assets/images/advantage.png" class="icon" alt="">
            </div>
            <div class="child text-center">
                <img src="@/assets/images/advantage.png" class="icon" alt="">
            </div>
            <div class="child text-center">
                <img src="@/assets/images/advantage.png" class="icon" alt="">
            </div>
        </div>
        <div class="items flex-bt">
            <div class="child">
                簡易推廣優惠設定(產品捆綁)
            </div>
            <div class="child text-center">
                <img src="@/assets/images/advantage.png" class="icon" alt="">
            </div>
            <div class="child text-center">
                <img src="@/assets/images/advantage.png" class="icon" alt="">
            </div>
            <div class="child text-center">
                <img src="@/assets/images/advantage.png" class="icon" alt="">
            </div>
        </div>
        <div class="items flex-bt">
            <div class="child">
                超強數據分析
            </div>
            <div class="child text-center">
                <img src="@/assets/images/advantage.png" class="icon" alt="">
            </div>
            <div class="child text-center">
                <img src="@/assets/images/advantage.png" class="icon" alt="">
            </div>
            <div class="child text-center">
                <img src="@/assets/images/advantage.png" class="icon" alt="">
            </div>
        </div>
        <div class="items flex-bt">
            <div class="child active">
                輕鬆同步直播至社交平台 (Facebook, Youtube)
            </div>
            <div class="child text-center">
                <img src="@/assets/images/advantage.png" class="icon" alt="">
            </div>
            <div class="child text-center">
                <img src="@/assets/images/advantage.png" class="icon" alt="">
            </div>
            <div class="child text-center">
                <img src="@/assets/images/advantage.png" class="icon" alt="">
            </div>
        </div>
        <div class="items flex-bt">
            <div class="child flex-start">
                收款方式
                <div class="tips flex-start">
                    <img class="tips-icon" src="@/assets/images/tips.png" alt="">
                    <div class="info">每項交易會抽取 2.9%手續費</div>
                </div>
            </div>
            <div class="child pay-icon">
                <img class="icon-items" src="@/assets/images/pay-icon-1.png" alt="">
                <img class="icon-items" src="@/assets/images/pay-icon-2.png" alt="">
                <img class="icon-items" src="@/assets/images/pay-icon-3.png" alt="">
                <img class="icon-items" src="@/assets/images/pay-icon-4.png" alt="">
                <img class="icon-items" src="@/assets/images/pay-icon-5.png" alt="">
                <img class="icon-items" src="@/assets/images/pay-icon-6.png" alt="">
                <img class="icon-items" src="@/assets/images/pay-icon-7.png" alt="">
                <img class="icon-items" src="@/assets/images/pay-icon-8.png" alt="">
                <img class="icon-items" src="@/assets/images/pay-icon-9.png" alt="">
                <img class="icon-items" src="@/assets/images/pay-icon-10.png" alt="">
                <img class="icon-items" src="@/assets/images/pay-icon-11.png" alt="">
                <img class="icon-items" src="@/assets/images/pay-icon-12.png" alt="">
            </div>
        </div>

        <div class="items big-title flex-bt">
            更多強大功能即將登場
        </div>
        <div class="items flex-bt">
            <div class="child active">
                全港首創KOL分銷祕密工具
            </div>
            <div class="child text-center">
                —
            </div>
            <div class="child text-center">
                —
            </div>
            <div class="child text-center">
                <img src="@/assets/images/advantage.png" class="icon" alt="">
            </div>
        </div>
        <div class="items flex-bt">
            <div class="child">
                輕鬆同步直播至社交平台 (Facebook, Youtube)
            </div>
            <div class="child text-center">
                <img src="@/assets/images/advantage.png" class="icon" alt="">
            </div>
            <div class="child text-center">
                <img src="@/assets/images/advantage.png" class="icon" alt="">
            </div>
            <div class="child text-center">
                <img src="@/assets/images/advantage.png" class="icon" alt="">
            </div>
        </div>
        <div class="items flex-bt">
            <div class="child active">
                極速AI圖片編輯神製
            </div>
            <div class="child text-center">
                上限20張相
            </div>
            <div class="child text-center">
                上限50張相
            </div>
            <div class="child text-center">
                上限80張相
            </div>
        </div>
        <div class="items flex-bt">
            <div class="child">
                智能倉庫發貨系統
            </div>
            <div class="child text-center">
                <img src="@/assets/images/advantage.png" class="icon" alt="">
            </div>
            <div class="child text-center">
                <img src="@/assets/images/advantage.png" class="icon" alt="">
            </div>
            <div class="child text-center">
                <img src="@/assets/images/advantage.png" class="icon" alt="">
            </div>
        </div>
        <div class="items flex-bt">
            <div class="child">
                會員積分系統
            </div>
            <div class="child text-center">
                <img src="@/assets/images/advantage.png" class="icon" alt="">
            </div>
            <div class="child text-center">
                <img src="@/assets/images/advantage.png" class="icon" alt="">
            </div>
            <div class="child text-center">
                <img src="@/assets/images/advantage.png" class="icon" alt="">
            </div>
        </div>
        <div class="items flex-bt">
            <div class="child">
                獨家導出直播留言
            </div>
            <div class="child text-center">
                <img src="@/assets/images/advantage.png" class="icon" alt="">
            </div>
            <div class="child text-center">
                <img src="@/assets/images/advantage.png" class="icon" alt="">
            </div>
            <div class="child text-center">
                <img src="@/assets/images/advantage.png" class="icon" alt="">
            </div>
        </div>
        <div class="items flex-bt">
            <div class="child">
                員工權限設置
            </div>
            <div class="child text-center">
                <img src="@/assets/images/advantage.png" class="icon" alt="">
            </div>
            <div class="child text-center">
                <img src="@/assets/images/advantage.png" class="icon" alt="">
            </div>
            <div class="child text-center">
                <img src="@/assets/images/advantage.png" class="icon" alt="">
            </div>
        </div>
    </div>
</template>
<script>
export default {
    props: {
        fee: {
            type: Array,
            default: () => []
        }
    },
}
</script>
<style lang="scss" scoped>
.price-box {
    border: 1px solid rgba(204, 204, 204, 1);
    margin-top: 0.32rem;

    .items {
        border-bottom: 1px solid rgba(204, 204, 204, 1);
        align-items: stretch;

        &.big-title {
            font-family: 'PingFang HK';
            font-style: normal;
            font-weight: 400;
            font-size: 0.24rem;
            line-height: 0.34rem;
            color: #000000;
            padding: 0.12rem 0.32rem;
            background: rgba(214, 246, 246, 1);
        }


        &:last-child {
            border: none;
        }

        .child {
            flex: 1;
            border-right: 1px solid rgba(204, 204, 204, 1);
            padding: 0.32rem;
            font-family: 'PingFang HK';
            font-style: normal;
            font-weight: 400;
            font-size: 0.16rem;
            line-height: 0.30rem;
            position: relative;
            word-break: break-all;

            &.text-center {
                text-align: center;
            }

            &.pay-icon {
                width: 55%;
                flex: auto;
                display: flex;
                align-items: center;
                justify-content: center;
                flex-wrap: wrap;

                .icon-items {
                    width: 0.74rem;
                    height: 0.42rem;
                    margin: 6px;
                    display: block;
                }
            }


            .tips {
                position: relative;

                &:hover {
                    .info {
                        display: block;
                    }
                }

                .tips-icon {
                    width: 0.2rem;
                    height: 0.2rem;
                    margin-left: 0.06rem;
                    display: block;
                }

                .info {
                    display: none;
                    position: absolute;
                    width: 2.2rem;
                    left: 0.4rem;
                    top: -50%;
                    padding: 0.08rem;
                    background: #0BD9D5;
                    border-radius: 0.08rem;
                    font-family: 'PingFang HK';
                    font-style: normal;
                    font-weight: 400;
                    font-size: 0.16rem;
                    line-height: 0.22rem;
                    color: #000000;
                    z-index: 99;
                }
            }

            .icon {
                width: 0.2rem;
                height: 0.2rem;
                display: block;
                margin: auto;
                position: absolute;
                top: 0;
                left: 0;
                right: 0;
                bottom: 0;
            }

            &.active {
                font-family: 'PingFang HK';
                font-style: normal;
                font-weight: 600;
                font-size: 0.2rem;
                line-height: 0.28rem;
                color: #E02E43;
                display: flex;
                justify-content: flex-start;
            }

            /* Black/100 */

            color: #000000;


            &:last-child {
                border: none;
            }

            .none {
                opacity: 0;
            }

            .title {
                padding-top: 0.3rem;
                font-family: 'PingFang HK';
                font-style: normal;
                font-weight: 600;
                font-size: 0.24rem;
                line-height: 0.34rem;
                color: #000000;
            }

            .old-price {
                font-family: 'PingFang HK';
                font-style: normal;
                font-weight: 400;
                font-size: 0.24rem;
                line-height: 0.24rem;
                color: #808080;
                margin: 0.27rem 0 0.18rem 0;
                height: 0.24rem;
                text-decoration: line-through
            }

            .price {
                font-family: 'PingFang HK';
                font-style: normal;
                font-weight: 600;
                font-size: 0.32rem;
                line-height: 0.32rem;
                color: #000000;

                span {
                    font-size: 0.18rem;
                }
            }

            .buy {
                width: 100%;
                height: 0.64rem;
                border: 1px solid #E02E43;
                color: #E02E43;
                border-radius: 0.08rem;
                margin: 0 auto;
                margin-top: 0.18rem;
                text-align: center;
                font-family: 'PingFang HK';
                font-style: normal;
                font-weight: 600;
                font-size: 0.24rem;
                line-height: 0.64rem;
                cursor: pointer;
            }
        }
    }
}

@media (max-width: 750px) {
    .price-box {
        padding: 0;
    }

    .price-box .items .child .price {
        font-size: 0.28rem;
        line-height: 0.28rem;
    }

    .price-box .items .child.pay-icon {
        width: 59%;
    }

    .price-box .items .child {
        word-break: break-all;
    }
}
</style>